"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _BlockMenuScroller_brand = /*#__PURE__*/new WeakSet();
var BlockMenuScroller = /*#__PURE__*/function () {
  function BlockMenuScroller(_board) {
    (0, _classCallCheck2["default"])(this, BlockMenuScroller);
    _classPrivateMethodInitSpec(this, _BlockMenuScroller_brand);
    this.board = _board;
    this.board.changeEvent.attach(this, _assertClassBrand(_BlockMenuScroller_brand, this, _reset));
    this.svgGroup = null;
    this.hX = 0;
    this.vWidth = 0;
    this.vY = 0;
    this.vRatio = 0;
    this._visible = true;
    this._opacity = -1;
    this.createScrollBar();
    this.setOpacity(0);
    $(this.vScrollbar).bind('mousedown', _assertClassBrand(_BlockMenuScroller_brand, this, _onMouseDown).bind(this));
    this._domHeight = 0;
    this._dResizeScrollBar = (0, _debounce["default"])(this.resizeScrollBar, 50);
    if (Entry.windowResized) {
      Entry.windowResized.attach(this, this._dResizeScrollBar);
    }
  }
  return (0, _createClass2["default"])(BlockMenuScroller, [{
    key: "SCROLL_WIDTH",
    get: function get() {
      return 8;
    }
  }, {
    key: "RADIUS",
    get: function get() {
      return 2.5;
    }
  }, {
    key: "createScrollBar",
    value: function createScrollBar() {
      var r = this.RADIUS;
      var width = this.SCROLL_WIDTH;
      var _ref = EntryStatic.colorSet || {},
        _ref$common = _ref.common,
        common = _ref$common === void 0 ? {} : _ref$common;
      this.svgGroup = this.board.svgGroup.elem('g', {
        "class": 'boardScrollbar'
      });
      this.vScrollbar = this.svgGroup.elem('rect', {
        width: width,
        rx: r,
        ry: r,
        fill: common.SCROLL_BAR || '#aac5d5',
        "class": 'scrollbar'
      });
    }
  }, {
    key: "resizeScrollBar",
    value: function resizeScrollBar() {
      _assertClassBrand(_BlockMenuScroller_brand, this, _updateRatio).call(this);
      var dom = this.board.blockMenuContainer;
      var newHeight = dom.height();
      if (newHeight !== this._domHeight) {
        this._domHeight = newHeight;
        return this.board.align();
      }
      if (!this._visible || this.vRatio === 0) {
        return;
      }
      if (this.vRatio === 0) {
        return;
      }
      var width = this.SCROLL_WIDTH;
      this.vScrollbar.attr({
        width: width,
        height: dom.height() / this.vRatio,
        x: dom.width() - 13
      });
    }
  }, {
    key: "updateScrollBar",
    value: function updateScrollBar(dy) {
      this.vY += dy;
      this.vScrollbar.attr({
        y: this.vY
      });
    }
  }, {
    key: "scroll",
    value: function scroll(dy) {
      if (!this.isVisible()) {
        return;
      }
      var dest = _assertClassBrand(_BlockMenuScroller_brand, this, _adjustValue).call(this, dy);
      dy = dest - this.vY;
      if (dy === 0) {
        return;
      }
      this.board.code.moveBy(0, -dy * this.vRatio);
      this.updateScrollBar(dy);
    }
  }, {
    key: "scrollByPx",
    value: function scrollByPx(px) {
      if (!this.vRatio) {
        _assertClassBrand(_BlockMenuScroller_brand, this, _updateRatio).call(this);
      }
      this.scroll(px / this.vRatio);
    }
  }, {
    key: "setVisible",
    value: function setVisible(visible) {
      if (visible === this.isVisible()) {
        return;
      }
      this._visible = visible;
      this.svgGroup.attr({
        display: visible === true ? 'block' : 'none'
      });
    }
  }, {
    key: "getOpacity",
    value: function getOpacity() {
      return this._opacity;
    }
  }, {
    key: "setOpacity",
    value: function setOpacity(value) {
      if (this._opacity == value) {
        return;
      }
      this.vScrollbar.attr({
        opacity: value
      });
      this._opacity = value;
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this._visible;
    }
  }]);
}();
function _updateRatio() {
  var board = this.board;
  var bRect = board.svgBlockGroup.getBBox();
  var realHeight = board.blockMenuContainer.height();
  var vRatio = (bRect.height + 20) / realHeight;
  this.vRatio = vRatio;
  if (vRatio <= 1) {
    this.setVisible(false);
  } else {
    this.setVisible(true);
  }
}
function _reset() {
  this.vY = 0;
  this.vScrollbar.attr({
    y: this.vY
  });
  this._dResizeScrollBar();
}
//adjust value by dy for min/max value
function _adjustValue(dy) {
  var domHeight = this.board.svgDom.height();
  var limitBottom = domHeight - domHeight / this.vRatio;
  var newY = this.vY + dy;
  newY = Math.max(0, newY);
  newY = Math.min(limitBottom, newY);
  return newY;
}
function _onMouseDown(e) {
  var _this = this;
  var onMouseMove = function onMouseMove(e) {
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    if (e.preventDefault) {
      e.preventDefault();
    }
    if (e.which == 2) {
      console.log('mouse wheel click disabled');
      return;
    }
    var mouseEvent;
    if (e.originalEvent && e.originalEvent.touches) {
      mouseEvent = e.originalEvent.touches[0];
    } else {
      mouseEvent = e;
    }
    var dragInstance = _this.dragInstance;
    _this.scroll(mouseEvent.pageY - dragInstance.offsetY);
    dragInstance.set({
      offsetY: mouseEvent.pageY
    });
  };
  var onMouseUp = function onMouseUp() {
    $(document).unbind('.scroll');
    delete _this.dragInstance;
  };
  if (e.stopPropagation) {
    e.stopPropagation();
  }
  if (e.preventDefault) {
    e.preventDefault();
  }
  if (e.button === 0 || e.originalEvent && e.originalEvent.touches) {
    if (Entry.documentMousedown) {
      Entry.documentMousedown.notify(e);
    }
    var mouseEvent;
    if (e.originalEvent && e.originalEvent.touches) {
      mouseEvent = e.originalEvent.touches[0];
    } else {
      mouseEvent = e;
    }
    var doc = $(document);
    doc.bind('mousemove.scroll', onMouseMove);
    doc.bind('mouseup.scroll', onMouseUp);
    this.dragInstance = new Entry.DragInstance({
      startY: mouseEvent.pageY,
      offsetY: mouseEvent.pageY
    });
  }
  e.stopPropagation();
}
Entry.BlockMenuScroller = BlockMenuScroller;
(function (p) {})(Entry.BlockMenuScroller.prototype);